import { FCC } from "@/types/common";
import { TGetCompanyExistsDto } from "@/api/services/main/company/dtos/get-company.dto";
import { Modal } from "@/components/elements/Modal";
import { Box } from "@mui/system";
import { Stack, Typography, Link } from "@mui/material";
import { secondary, text } from "@/theme/colors";
import { getDynamicRoute } from "@/utils/url";
import { AppRoutes } from "@/routes/config";
import { useParams } from "react-router-dom";

type TDuplicateCompanyModalProps = {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  companies: TGetCompanyExistsDto[];
};

export const DuplicateCompanyModal: FCC<TDuplicateCompanyModalProps> = ({ open, onClose, onSave, companies }) => {
  const handleClick = (companyId: string) => {
    const detailRoute = getDynamicRoute(AppRoutes.companyDetail, { companyId });
    window.open(detailRoute, "_blank");
  };
  const { companyId } = useParams();
  const labelOk = companyId ? "保存" : "新規で登録する";
  return (
    <Modal isOpen={open} onClose={onClose} onOk={onSave} labelClose="キャンセル" labelOk={labelOk} width={500} enableFooter={true}>
      <Box mb={2}>
        <Typography variant="body1" sx={{ mb: 2, mt: 1 }}>
          同名の企業が登録されています。確認してください。
        </Typography>
        <Stack spacing={1.5}>
          {companies.map((company) => (
            <Box
              key={company.id}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography
                component="span"
                sx={{
                  color: text.primary,
                  lineHeight: 1,
                  flexShrink: 0,
                }}
              >
                ・
              </Typography>
              <Link
                component="button"
                variant="body1"
                onClick={() => handleClick(String(company.id))}
                sx={{
                  textDecoration: "none",
                  color: secondary[80],
                  cursor: "pointer",
                  textAlign: "left",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                {company.name}
              </Link>
            </Box>
          ))}
        </Stack>
      </Box>
    </Modal>
  );
};
